<template>
  <component :is="triggerOnHover ? 'VMenu' : 'VDropdown'">
    <CButton
      :class="triggerClass"
      :icon="triggerIcon"
      :iconSecondary="triggerIconSecondary"
      :tooltip="triggerTooltip"
      :aria-label="triggerAriaLabel"
      :color="triggerColor"
      :size="triggerSize"
      name="dropdownTrigger"
      :disabled="isDisabled"
      :data-testid="triggerDataTestid"
      :loading="isLoading"
      @click="$emit('click')"
    >
      {{ triggerLabel }}
    </CButton>
    <template #popper="{ hide }">
      <menu>
        <li v-for="button in buttons" :key="button.key || button.label">
          <hr v-if="button.type === 'separator'" class="my-2" />
          <component
            :is="button.type"
            v-if="button.type !== 'separator'"
            v-bind="omit(button, ['on'])"
            v-on="button.on(hide)"
          >
            {{ button.label }}
          </component>
        </li>
      </menu>
    </template>
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { DropdownMenuButton } from './types';
import type { colors } from './CButton.vue';
import { omit } from '@/helpers/helpers';
type Props = {
  triggerLabel?: string;
  triggerIcon?: string;
  triggerIconSecondary?: string;
  triggerClass?: string | string[] | Record<string, unknown>;
  triggerTooltip?: string;
  triggerAriaLabel?: string;
  triggerColor?: (typeof colors)[number];
  triggerSize?: 'sml';
  isDisabled?: boolean;
  isLoading?: boolean;
  buttonsList: DropdownMenuButton[];
  triggerOnHover?: boolean;
  triggerDataTestid?: string;
};

const props = withDefaults(defineProps<Props>(), {
  triggerClass: 'white',
  triggerIcon: 'expand_more',
});

defineEmits(['click']);

const buttons = computed(() =>
  props.buttonsList.filter(Boolean).map((button) => ({
    type: 'CButton',
    variant: 'menu',
    iconBefore: true,
    on: () => ({}),
    ...button,
  }))
);
</script>
